import type * as z from "zod";
import { searchInputOf, searchResultOf } from "../search";

// What sales finds (ADR-117): the sales orders by their number in Nexxt or on Joor. The type needs the permission of
// the list, and the same one opens it in the app.

export const salesSearchTypes = ["sales_order"] as const;
export type SalesSearchType = (typeof salesSearchTypes)[number];

export const salesSearchPermissions = {
  sales_order: "sales_order.read",
} as const satisfies Record<SalesSearchType, string>;

export const searchSalesInput = searchInputOf(salesSearchTypes);
export type SearchSalesInput = z.input<typeof searchSalesInput>;

export const salesSearchDto = searchResultOf(salesSearchTypes).meta({ id: "SalesSearch" });
export type SalesSearch = z.output<typeof salesSearchDto>;
